import React, { ReactNode } from 'react';
import { WprButton } from '../../wpr-framework/component/controls/WprButton';
import { WprViewError } from '../../wpr-framework/component/controls/WprViewError';
import { withRouter } from 'react-router';
import { WprInput } from '../../wpr-framework/component/controls/WprInput';
import { WprBaseRouteViewComponent } from '../../wpr-framework/view/component/WprBaseRouteViewComponent';
import { PersonalInfoComponentView } from './PersonalInfoComponentView';
import { WprRadio } from '../../wpr-framework/component/controls/WprRadio';
import { WprSelect } from '../../wpr-framework/component/controls/WprSelect';
import { WprRowInfo } from '../../wpr-framework/component/props/WprRowInfo';
import { HeaderComponent } from '../common/header/HeaderComponent';
import { FooterComponent } from '../common/footer/FooterComponent';
import { WprContainer } from '../../wpr-framework/component/controls/WprContainer';
import { WprSpan } from '../../wpr-framework/component/controls/WprSpan';
/**
 * 個人情報登録コンポーネント
 */
class PersonalInfoComponent extends WprBaseRouteViewComponent {
	// コンストラクタ  -----------------------------------------------------------
	constructor(props: any) {
		super(new PersonalInfoComponentView(), props);
	}

	public handleClick = (e: React.MouseEvent, props) => {
		e.nativeEvent.stopImmediatePropagation();
		const targetId = e.currentTarget.id;
		$('#' + targetId.replace('-lbl', '')).off('click');
	}
	// --------------------------------------------------------------------------

	// override メソッド  --------------------------------------------------------
	/**
	 * 描画
	 */
	public onRender(): ReactNode {
		return (
			<>
				<HeaderComponent />
				<div className="step">
					<div className="wrap">
						<div className="stepper">
							<ul>
								<li className="now"><span>5</span>
									<p className="conf" id="step5">お客様情報の登録</p>
								</li>
								<li className=""><span>6</span></li>
								<li className=""><span>7</span></li>
								<li className=""><span>8</span></li>
							</ul>
						</div>

					</div>
				</div>
				<div className="page-personal_info">
					<div className="top">
						<h1>契約者と旅行者の情報を<br />入力してください</h1>
					</div>
					{/* <form id="form" method="post"> */}
					<section className="contract" id="contractor">
						<h2 className="c-headline">契約者（申込者）</h2>
						<div className="wrap-contract c-list">
							<dl>
								<dt>姓名（漢字・平仮名・カタカナ）</dt><dd className="c-input">
									<div className="double">
										<WprInput name="lastNameContractor" type="text" placeholder="例）洲井須" view={this.view} id="id-l-name-c"/>
										<WprInput name="firstNameContractor" type="text" placeholder="例）太郎" view={this.view} id="id-f-name-c" />
									</div>
									<div className="c-errmsg">
										<WprViewError name="lastNameContractor" view={this.view} />
										<WprViewError name="firstNameContractor" view={this.view} />
									</div>
								</dd>
							</dl>
							<dl>
								<dt>姓名（ローマ字）</dt><dd className="c-input">
									<div className="double">
										<WprInput name="romanLastNameContractor" type="text" placeholder="例）SUISU" view={this.view} id="id-rl-name-c"/>
										<WprInput name="romanFirstNameContractor" type="text" placeholder="例）TARO" view={this.view} id="id-rf-name-c"/>
									</div>
									<div className="c-errmsg">
										<WprViewError name="romanLastNameContractor" view={this.view} />
										<WprViewError name="romanFirstNameContractor" view={this.view} />
									</div>
								</dd>
							</dl>
							<dl>
								<dt>生年月日</dt>
								<dd>
									<div className="c-birth">
										<div className="c-select year">
											<WprSelect name="yearContractor" view={this.view} vm='year' placeholder="年"/>
										</div>
										<div className="c-select month">
											<WprSelect name="monthContractor" view={this.view} vm='month' placeholder="月"/>
										</div>
										<div className="c-select date">
											<WprSelect name="dateContractor" view={this.view} vm='date' placeholder="日"/>
										</div>
									</div>
									<WprViewError className="c-errmsg" name="yearContractor, monthContractor, dateContractor" dispMax={1} view={this.view} />
								</dd>
							</dl>
							<dl>
								<dt>性別</dt>
								<dd className="c-radio">
									<WprRadio id="id-sex-men" name="genderContractor" value="M" view={this.view} />
									<label htmlFor="id-sex-men" id="id-sex-men-lbl" onClick={e => this.handleClick(e, this.props)}><div><span>男性</span></div></label>
									<WprRadio id="id-sex-women" name="genderContractor" value="F" view={this.view} />
									<label htmlFor="id-sex-women" id="id-sex-women-lbl" onClick={e => this.handleClick(e, this.props)}><div><span>女性</span></div></label>
									<div className="c-errmsg">
										<WprViewError name="genderContractor" view={this.view} />
									</div>
								</dd>
							</dl>
							<dl>
								<dt>郵便番号</dt><dd className="c-input">
									<WprInput name="postalCode" type="text" placeholder="例）1234567" view={this.view} id="id-post-code"/>
									<div className="c-errmsg">
										<WprViewError name="postalCode" view={this.view} />
									</div>
								</dd>
							</dl>
							<dl>
								<dt>都道府県</dt>
								<dd>
									<div className="c-select">
										<WprSelect name="prefecture" view={this.view} vm='prefectures' placeholder="選択してください"/>
									</div>
									<div className="c-errmsg">
										<WprViewError name="prefecture" view={this.view} />
									</div>
								</dd>
							</dl>
							<dl>
								<dt>住所１</dt>
								<dd className="c-input"><WprInput name="address1" type="text" view={this.view} id="id-address1"/>
									<div className="c-errmsg">
										<WprViewError name="address1" view={this.view} />
									</div>
								</dd>
							</dl>
							<dl>
								<dt>住所２</dt>
								<dd className="c-input"><WprInput name="address2" type="text" placeholder="例）１２３－１チューリッヒマンション１２３号室 " view={this.view} id="id-address2"/>
									<div className="c-errmsg">
										<WprViewError name="address2" view={this.view} />
									</div>
								</dd>
							</dl>
							<dl>
								<dt>電話番号</dt>
								<dd className="c-input"><WprInput name="tel" type="text" placeholder="例）0312345678" view={this.view} id="id-tel"/>
									<div className="c-errmsg">
										<WprViewError name="tel" view={this.view} />
									</div>
								</dd>
							</dl>
						</div>
					</section>
					<section className="traveler">
						{this.renderList('TravelerInfo')}
					</section>
					<section className="login">
						<h2 className="c-headline">ログイン情報</h2>
						<div className="wrap-login c-list">
							<dl>
								<dt>ログインID</dt>
								<dd>
									<p className="plane">契約手続き完了時にお知らせします</p>
								</dd>
							</dl>
							<dl>
								<dt>パスワードを決めてください</dt>
								<dd className="c-input">
									<WprInput type="password" name="loginPass" placeholder="半角8文字以上（大文字英字・小文字英字・数字・記号から2種以上含む）" view={this.view} id="id-pass"/>
									<WprViewError className="c-errmsg" name="loginPass" view={this.view} />
								</dd>
							</dl>
							<div className="note">
								<p>
									&lt;パスワードは以下の条件を全て満たしてください&gt;<br />
									・８文字以上<br />
									・大文字英字・小文字英字・数字・記号（-_.*!#$%&amp;+/=?^`&#123;|&#125;~@）のいずれか２種類以上を含む<br />
									例)　travel90
								</p>
							</div>
							<dl>
								<dt className="checkpass">パスワード<br />（確認のため再入力してください）</dt>
								<dd className="c-input">
									<WprInput type="password" name="loginPassAgain" placeholder="半角8文字以上（大文字英字・小文字英字・数字・記号から2種以上含む）" view={this.view} id="id-pass-again"/>
									<WprViewError className="c-errmsg" name="loginPassAgain" view={this.view} />
								</dd>
							</dl>
						</div>
						<div className="next">
							<WprButton className="c-button" name="toNext" view={this.view}><span>申し込み内容の確認に進む</span></WprButton>
						</div>
					</section>
					<WprContainer mode='selectAddress' view={this.view}>
						<div className="c-layer layer-postal">
							<div className="box">
								<WprButton className="close-button" name="closebtn" view={this.view}></WprButton>
								<h2>ご住所を選択してください</h2>
								{/* <button className="close-button"></button> */}
								<ul>
								    {/* WRQ2083 住所検索のエラー修正 S */}
									{/* {this.renderList('AddressList')} */}
									{this.renderList('AddressSelectList')}
									{/* WRQ2083 住所検索のエラー修正 E */}
								</ul>
								<WprButton className="button" name="selectbtn" view={this.view}>OK</WprButton>
							</div>
						</div>
					</WprContainer>
				</div>
				<FooterComponent />
			</>
		);
	}

	/**
	 * リスト描画
	 * @param listName リスト名
	 * @param rowInfo 行情報
	 */
	protected onRenderList(listName: string, rowInfo: WprRowInfo): any {
		if (listName === 'TravelerInfo') {
			return (
				<div key={rowInfo.index}>
					<div className="traveler01" id={'traveler' + rowInfo.index}>
						<h2 className="c-headline">
							旅行者（記名被保険者）-{this.zenkaku(rowInfo.index + 1)} 情報
						</h2>
						<div className="wrap-traveler c-list">
							<WprButton className="c-edit-button" name="copy" view={this.view} row={rowInfo}><span>申込者と同じ<br />（入力内容を反映します。）</span></WprButton>
							<dl>
								<dt>姓名（ローマ字）</dt><dd className="c-input">
									<div className="double">
										<WprInput name="romanLastNameTraveler" type="text" placeholder="例）SUISU" view={this.view} row={rowInfo} id={'id-rl-name-t' + rowInfo.index}/>
										<WprInput name="romanFirstNameTraveler" type="text" placeholder="例）TARO" view={this.view} row={rowInfo} id={'id-rf-name-t' + rowInfo.index}/>
									</div>
									<div className="c-errmsg">
										<WprViewError name="romanLastNameTraveler" view={this.view} row={rowInfo} />
										<WprViewError name="romanFirstNameTraveler" view={this.view} row={rowInfo} />
									</div>
								</dd>
							</dl>
							<dl>
								<dt>生年月日</dt>
								<dd>
									<div className="c-birth">
										<div className="c-select year">
											<WprSelect name="yearTraveler" view={this.view} row={rowInfo} vm='year' placeholder="年"/>
										</div>
										<div className="c-select month">
											<WprSelect name="monthTraveler" view={this.view} row={rowInfo} vm='month' placeholder="月"/>
										</div>
										<div className="c-select date">
											<WprSelect name="dateTraveler" view={this.view} row={rowInfo} vm='date' placeholder="日"/>
										</div>
									</div>
									<WprViewError className="c-errmsg" name="yearTraveler, monthTraveler, dateTraveler" dispMax={1} view={this.view} row={rowInfo} />
								</dd>
							</dl>
							<dl>
								<dt>性別</dt>
								<dd className="c-radio">
									<WprRadio id={'gender-men' + rowInfo.index} name="genderTraveler" value="M" view={this.view} row={rowInfo} />
									<label htmlFor={'gender-men' + rowInfo.index} id={'gender-men' + rowInfo.index + '-lbl'} onClick={e => this.handleClick(e, this.props)}><div><span>男性</span></div></label>
									<WprRadio id={'gender-women' + rowInfo.index} name="genderTraveler" value="F" view={this.view} row={rowInfo} />
									<label htmlFor={'gender-women' + rowInfo.index} id={'gender-women' + rowInfo.index + '-lbl'} onClick={e => this.handleClick(e, this.props)}><div><span>女性</span></div></label>
									<div className="c-errmsg">
										<WprViewError name="genderTraveler" view={this.view} row={rowInfo} />
									</div>
								</dd>
							</dl>
						</div>
					</div>
				</div>
			);
		}
		// 住所リスト
		// WRQ2083 住所検索のエラー修正 S
		// if(listName === 'AddressList') {
		if(listName === 'AddressSelectList') {
		// WRQ2083 住所検索のエラー修正 E
			return(
				<li key={rowInfo.index}>
					<label>
						<WprRadio id="adrslist" name="radioSelect" view={this.view} value={''+rowInfo.index} />
						<WprSpan name="adrsInfo" view={this.view} row={rowInfo}/>
					</label>
				</li>

			);
		}
		return null;
	}
	// --------------------------------------------------------------------------

	/**
	 * 数字の半角→全角変換
	 * @param num 
	 */
	private zenkaku(num: number) {
		return String(num).replace(/[0-9]/g, function (s: string) {
			return String.fromCharCode(s.charCodeAt(0) + 0xFEE0);
		});
	}
}
export default withRouter(PersonalInfoComponent);